import { BrowserRouter, Navigate, Outlet, Route, RouteProps, Routes, redirect } from 'react-router-dom';
import TokenServices from '../services/token';
import { ReactNode, useEffect, useState } from 'react';
import LoginPage from './auth/login';
import API from '../services/api-service';
import ApiEndpoints from '../services/api-endpoints';
import LeadListingPage from './leads';
import LeadEntryPage from './leads/entry';
import { useAuth } from '../hooks/use-auth';
import { Layout, Spin } from 'antd';
import { NotFoundPage } from './notfound/Loadable';
import AppLayout from '../components/Layout';
import SettingPage from './settings';
import CategorySourcePage from './settings/cat-source';
import StatisticsPage from './statistics';
import { HomePage } from './home';
import ChangePasswordPage from './settings/change-password';
import PermissionPage from './permission';
import MentorListingPage from './mentor';
import OrderEntryPage from './orders/entry';
import OrderListingPage from './orders';
import InventoryWorkersPage from './statistics/inventory-workers';
import CustomerListingPage from './customers';
import WorkItemsPage from './settings/work-items';
import WorkPolicyPage from './settings/work-policy';
import WorkerPage from './settings/worker';
import WorkloadPage from './workers/workload';
import ProductPage from './settings/products';

const ProtectedRoute = ({ roles, children }: any) => {
  const { isAuthenticated, loading, userInfo } = useAuth();
  if (loading) {
    return (
      <div className="w-screen h-screen flex justify-center items-center">
        <Spin />
      </div>
    );
  }
  if (!isAuthenticated) {
    return <Navigate to={{ pathname: '/login' }} replace />;
  }
  if (roles?.length > 0) {
    if (!roles.includes(userInfo?.role)) {
      return <Navigate to={{ pathname: '/notfound' }} replace />;
    }
  }
  return <Outlet />;
};

const RouteUser = ({ children }: any) => {
  const { isAuthenticated, loading, userInfo } = useAuth();

  if (loading) {
    return (
      <div className="w-screen h-screen flex justify-center items-center">
        <Spin />
      </div>
    );
  }
  if (isAuthenticated) {
    return <Navigate to={{ pathname: '/leads' }} replace />;
  }
  return children;
};

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route
          path="/login"
          element={
            <RouteUser>
              <LoginPage />
            </RouteUser>
          }
        />
        <Route path="/workers/workload/:hash" element={<WorkloadPage />} />
        <Route
          path="/"
          element={
            <ProtectedRoute>
              <HomePage />
            </ProtectedRoute>
          }
        >
          <Route
            path="/"
            element={
              <AppLayout>
                <HomePage />
              </AppLayout>
            }
          />
          <Route
            path="/leads"
            element={
              <AppLayout>
                <LeadListingPage />
              </AppLayout>
            }
          />
          <Route
            path="/leads/:id"
            element={
              <AppLayout>
                <LeadEntryPage />
              </AppLayout>
            }
          />
          <Route
            path="/orders"
            element={
              <AppLayout>
                <OrderListingPage />
              </AppLayout>
            }
          />
          <Route
            path="/orders/:id"
            element={
              <AppLayout>
                <OrderEntryPage />
              </AppLayout>
            }
          />
          <Route
            path="/inventory-workers"
            element={
              <AppLayout>
                <InventoryWorkersPage />
              </AppLayout>
            }
          />
          <Route
            path="/mentor"
            element={
              <AppLayout>
                <MentorListingPage />
              </AppLayout>
            }
          />
          <Route
            path="/customers"
            element={
              <AppLayout>
                <CustomerListingPage />
              </AppLayout>
            }
          />
          <Route
            path="/settings"
            element={
              <AppLayout>
                <SettingPage />
              </AppLayout>
            }
          />
          <Route
            path="/settings/sources"
            element={
              <AppLayout>
                <CategorySourcePage />
              </AppLayout>
            }
          />
          <Route
            path="/settings/types"
            element={
              <AppLayout>
                <CategorySourcePage apiUrl="/api/categories/types" title="Danh mục: Nguồn khách hàng" />
              </AppLayout>
            }
          />
          <Route
            path="/settings/products"
            element={
              <AppLayout>
                <ProductPage apiUrl="/api/products" title="Quản lý: Danh sách sản phẩm" />
              </AppLayout>
            }
          />
          <Route
            path="/settings/product-category"
            element={
              <AppLayout>
                <CategorySourcePage apiUrl="/api/products/categories" title="Quản lý: Danh mục sản phẩm" />
              </AppLayout>
            }
          />
          <Route
            path="/settings/work-items"
            element={
              <AppLayout>
                <WorkItemsPage title="Quản lý: Hạng mục thi công/lắp đặt" />
              </AppLayout>
            }
          />
          <Route
            path="/settings/work-policies"
            element={
              <AppLayout>
                <WorkPolicyPage apiUrl="/api/work-policies" title="Quản lý: Cấu hình chính sách công" />
              </AppLayout>
            }
          />
          <Route
            path="/settings/work-extra-fee"
            element={
              <AppLayout>
                <CategorySourcePage apiUrl="/api/work-extra-fee" title="Quản lý: Cấu hình phụ phí" />
              </AppLayout>
            }
          />
          <Route
            path="/settings/workers"
            element={
              <AppLayout>
                <WorkerPage />
              </AppLayout>
            }
          />
          <Route
            path="/settings/change-password"
            element={
              <AppLayout>
                <ChangePasswordPage />
              </AppLayout>
            }
          />
          <Route
            path="/statistics"
            element={
              <AppLayout>
                <StatisticsPage />
              </AppLayout>
            }
          />
          <Route
            path="/permissions"
            element={
              <AppLayout>
                <PermissionPage />
              </AppLayout>
            }
          />
        </Route>

        <Route path="*" element={<NotFoundPage />} />
      </Routes>
    </BrowserRouter>
  );
}
